/**
 * Награды и рейтинг для итогов ПРОСМОТРА ЗАПИСИ — из карточки матча.
 *
 * Запасной путь для записей, сделанных до того, как награды стали попадать в
 * саму запись (экшен SET_EXTENDED_GAME_RESULTS раньше диспатчился уже ПОСЛЕ
 * сохранения записи). В новых записях он есть, и этот путь не нужен вовсе.
 *
 * Тонкость: в карточке матча лежат ДВЕ дельты рейтинга. `ratingDelta` —
 * отображаемая в истории матчей, а модалка итогов показывает исходную,
 * `originalRatingDelta` (см. сборку extendedGameResults на сервере). Берем
 * именно ее, иначе в записи и в живом матче показались бы разные числа.
 *
 * @param {Object} match - документ матча (/api/matches/:matchId)
 * @returns {Array|null} записи в форме extendedGameResults или null, если данных нет
 */
export const buildExtendedResultsFromMatch = (match) => {
  const players = match && match.players;
  if (!Array.isArray(players) || players.length === 0) {
    return null;
  }

  return players
    .map((player) => {
      const id = player.playerId || player.userId;
      if (!id) {
        return null;
      }
      return {
        id: String(id),
        factionId: player.factionId || '',
        selectedSkin: player.selectedSkin || `${player.factionId || ''}_default`,
        ratingDelta: player.originalRatingDelta ?? player.ratingDelta ?? 0,
        rating: player.rating ?? 0,
        numens: player.numens ?? 0,
        chests: player.chests || [],
        skins: player.skins || [],
        isDoubleReward: Boolean(player.isDoubleReward),
        isPremiumReward: Boolean(player.isPremiumReward),
        premiumRewardDays: player.premiumRewardDays ?? 0,
        factionRewardId: player.factionRewardId ?? null,
        // Наградные модалки за задания в записи не показываем: это личные
        // события того игрока, а не часть партии
        questReward: null,
        completedQuestIds: [],
      };
    })
    .filter(Boolean);
};
